import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {signature,authcodereport ,testMsgSend} = api

/**
 * 查找
 */
export async function findSignature(params) {
    return request({url: signature, method: 'post', data: params,})
}
/**
 * 授权上报
 */
export async function updateAuthcodereport(params) {
    return request({url: authcodereport+`?hostUserId=${params.hostUserId}&authCode=${params.authCode}&expiresIn=${params.authCode}`, method: 'post', data: params,})
}
/**
 * 消息测试
 */
 export async function sendTestMsg(params) {
    return request({url: testMsgSend, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/signature.js